export default __webpack_public_path__ + "static/media/forest.72338cc1.jpg";